import BaseController from '@/core/controller/BaseController'

interface AreaCheckConfig {
  topy: number
  bottomy: number
}

class AreaCheckController extends BaseController {
  //
  private elements: Array<HTMLElement> = []

  //
  private position = 99999

  //
  private maxPosition = 0

  //
  private scrollY = 0

  //
  private margin = 0

  //
  private winTop = 0

  //
  private windowHeight = 0

  //
  private configs: Array<AreaCheckConfig> = []

  /**
   * コンストラクタ
   *
   */
  constructor(elements: Array<HTMLElement>) {
    super()

    this.elements = elements

    this.createConfig()
  }

  /**
   * 監視の開始
   */
  public run(): void {
    this.listenResize()
    this.listenScroll()
  }

  /**
   * 監視の開始
   */
  private update() {
    window.innerHeight

    //画面縦センター位置を算出
    const tmpScrollY = this.winTop + this.windowHeight / 2 + this.margin

    for (let i = 0; i < this.configs.length; i++) {
      if (
        this.configs[i].topy < tmpScrollY &&
        this.configs[i].bottomy > tmpScrollY
      ) {
        if (this.position != i) {
          this.position = i
          this.emit('changeIndex', this.position)
        }
      }
    }
  }

  /**
   * コンフィグを更新
   */
  private createConfig(): void {
    // 頭を挿入
    this.configs = []
    this.configs.push({ topy: 0, bottomy: 0 })

    for (let i = 0; i < this.elements.length; i++) {
      const elem = this.elements[i]
      const rect = elem.getBoundingClientRect()
      const topy = rect.top + this.getScrollPositionY()
      this.configs.push({ topy: topy, bottomy: topy + rect.height })
    }

    let config = this.configs[0]
    config.bottomy = this.configs[1].topy

    // 終わりを挿入
    config = this.configs[this.configs.length - 1]
    this.configs.push({ topy: config.topy + config.bottomy, bottomy: 99999 })

    //
    this.maxPosition = this.configs.length - 1
  }

  /**
   * スクロールイベントハンドラ
   *
   */
  public onScroll(scrollY: number, scrollX: number): void {
    this.winTop = scrollY
    this.update()
  }
  /**
   * リサイズイベントハンドラ
   *
   */
  public onResize(): void {
    this.windowHeight = window.innerHeight
    this.createConfig()
    this.update()
  }
}

export default AreaCheckController
